// ui-profile-form.js

export const pendingProfiles = [];

/**
 * Add a new profile to the pending list
 */
export function addProfile(name, norm) {
  if (!name || !norm) {
    alert('Please fill in both Name and Norm.');
    return;
  }

  pendingProfiles.push({ name, norm });
}

/**
 * Reset input fields
 */
export function resetProfileForm() {
  document.getElementById('settings-profile-name').value = '';
  document.getElementById('settings-profile-norm').value = '';
}

/**
 * Render preview tags in #profile-tags
 */
export function renderProfilePreview() {
  const tagContainer = document.getElementById('settings-profile-tags');
  tagContainer.innerHTML = '';

  pendingProfiles.forEach((profile, index) => {
    const tag = document.createElement('div');
    tag.className = 'settings-profile-tag';
    tag.innerHTML = `
      ${profile.name} (${profile.norm})
      <button class="remove-tag" title="Remove" data-index="${index}">&times;</button>
    `;
    tagContainer.appendChild(tag);
  });

  tagContainer.querySelectorAll('.remove-tag').forEach(btn => {
    btn.addEventListener('click', () => {
      const i = Number(btn.dataset.index);
      pendingProfiles.splice(i, 1);
      renderProfilePreview();
    });
  });
}